module.exports = __webpack_public_path__ + "img/63.6dd55d5e.jpg";